export default {
  initialize() {
    const enabled = (new URLSearchParams(location.search)).has('font-test');
    enabled && import(/* webpackChunkName: "styleguide/test"*/'./font-test.bundle').then(({init}) => init());
  }
};
